// Copyright © 2020 BREAS. All rights reserved

const createAppConfig = () => ({
    AppVersion: process.env.REACT_APP_EW_ADMIN_APP_VERSION,

    EnvironmentName: process.env.NODE_ENV,

    PublicUrl: process.env.REACT_APP_URL,
    AppId: process.env.REACT_APP_EW_APP_ID,
    TenantId: process.env.REACT_APP_EW_TENANT_ID,
    Authority: process.env.REACT_APP_EW_AUTHORITY,

    IsProd: process.env.NODE_ENV.toLowerCase() === 'production',
    IsDev: process.env.NODE_ENV.toLowerCase() === 'development',

    ApiUrl: process.env.REACT_APP_EW_API_URL
});

export default createAppConfig;
